import { gql } from "@apollo/client";

export const CREATE_EMPLOYEE_SKILLS = gql`
  mutation createEmployeeSkills($input: createemployeeSkillsInput) {
    createEmployeeSkills(input: $input) {
      employeeId
    }
  }
`;

export const GET_EMPLOYEE_SKILLS = gql`
  query employeeSkillsDetails($employeeId: String!) {
    employeeSkillsDetails(employeeId: $employeeId) {
      employeeId
      skillsandExp
      orgId
      Id
    }
  }
`;
export const UPDATE_EMPLOYEE_SKILLS_DETAILS = gql`
  mutation updateEmployeeSkills($input: updateemployeeSkillsInput) {
    updateEmployeeSkills(input: $input)
  }
`;
